import { hasClass } from "../../common/html";

export function initDisableContextMenu() {
	document.addEventListener("contextmenu", (ev) => {
		if (hasClass(ev.target as HTMLElement, "u-no-context-menu")) ev.preventDefault();
	});
}
